import Component from '@glimmer/component';

import moment from 'moment';

import {
	getVerifiedByName,
	getVerifiedDate,
	isVerified,
	type VerificationInfo,
} from 'webapp/utils/verification';

interface Args {
	verification?: VerificationInfo;
	createdByName?: string | null;
	createdTimestamp?: number | null;
	modifiedByName?: string | null;
	modifiedTimestamp?: number | null;
}

export default class MetricAuditInfoComponent extends Component<Args> {
	get isVerified(): boolean {
		return isVerified(this.args.verification);
	}

	get verifiedByName(): string {
		return getVerifiedByName(this.args.verification);
	}

	get verifiedDate(): string {
		return getVerifiedDate(this.args.verification);
	}

	get hasCreatedInfo(): boolean {
		return !!this.args.createdByName;
	}

	get createdDate(): string {
		if (!this.args.createdTimestamp) {
			return '';
		}
		return moment.unix(this.args.createdTimestamp).format('MMM D, YYYY');
	}

	get hasModifiedInfo(): boolean {
		return !!this.args.modifiedByName && !!this.args.modifiedTimestamp;
	}

	get modifiedDate(): string {
		if (!this.args.modifiedTimestamp) {
			return '';
		}
		return moment.unix(this.args.modifiedTimestamp).format('MMM D, YYYY');
	}

	get hasAnyInfo(): boolean {
		return this.hasCreatedInfo || this.isVerified || this.hasModifiedInfo;
	}

	<template>
		{{#if this.hasAnyInfo}}
			<div class="verification-info">
				{{#if this.hasCreatedInfo}}
					<div class="verification-info__row">
						<span class="verification-info__label">Created by</span>
						<span class="verification-info__name">{{@createdByName}}</span>
						<span class="verification-info__date">on {{this.createdDate}}</span>
					</div>
				{{/if}}
				{{#if this.isVerified}}
					<div class="verification-info__row">
						<span class="verification-info__label">Verified by</span>
						<span class="verification-info__name">{{this.verifiedByName}}</span>
						<span class="verification-info__date">on {{this.verifiedDate}}</span>
					</div>
				{{/if}}
				{{#if this.hasModifiedInfo}}
					<div class="verification-info__row">
						<span class="verification-info__label">Last edited by</span>
						<span class="verification-info__name">{{@modifiedByName}}</span>
						<span class="verification-info__date">on {{this.modifiedDate}}</span>
					</div>
				{{/if}}
			</div>
		{{/if}}
	</template>
}
